import { FETCH_SURVEY_REQUEST, FETCH_SURVEY_SUCCESS, FETCH_SURVEY_FAILURE, CREATE_SURVEY_REQUEST, CREATE_SURVEY_SUCCESS, CREATE_SURVEY_FAILURE } from "./types";

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const surveyReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SURVEY_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_SURVEY_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_SURVEY_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case CREATE_SURVEY_REQUEST:
            return { ...state, loading: true, success: false, error: null };
        case CREATE_SURVEY_SUCCESS:
            return { ...state, loading: false, success: true, error: null };
        case CREATE_SURVEY_FAILURE:
            return { ...state, loading: false, success: false, error: action.payload };
        default:
            return state;
    }
};

export default surveyReducer;
